/**
 * This file is automatically generated using generator/actions/generate-action.ts.
 * Do NOT modify this file by hand.
 */

import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { GetPublicReservableSpacePathParameters } from 'api/actions/get-public-reservable-space/get-public-reservable-space-path-parameters';
import { GetPublicReservableSpaceResponse } from 'api/actions/get-public-reservable-space/get-public-reservable-space-response';

type GetPublicReservableSpaceQueryParameters = Record<string, any>;

/**
 * The path of the GetPublicReservableSpace action.
 */
export const getPublicReservableSpaceActionPath = new SweetPath<keyof GetPublicReservableSpacePathParameters>(
  '/reservations/public/spaces/{slug}',
  { path: '{param}' }
);

/**
 * Creates a contextualized GetPublicReservableSpace actions.
 */
export default function createGetPublicReservableSpaceAction(axios: AxiosInstance) {
  return function getPublicReservableSpaceAction({
    headers = {},
    parameters,
    query = {},
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: GetPublicReservableSpacePathParameters;
    query?: GetPublicReservableSpaceQueryParameters;
  }) {
    const path = getPublicReservableSpaceActionPath.insert(parameters);

    return axios.get<GetPublicReservableSpaceResponse, GetPublicReservableSpaceResponse>(path, {
      params: query,
      headers,
    });
  };
}
